import { Position2D } from "../../core/space/position";

export const translate = (x: number, y = 0) => `translate(${x}, ${y})`;
export const translatePosition = (position: Position2D) =>
  `translate(${position.x}, ${position.y})`;
